//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from '../../config/settings';
///////////////////////////////////////////////////////////   COMPS
import VideojsVideoPlayer from '../../components/videojs-player/videojs-video-player/videojs-video-player.component';
///////////////////////////////////////////////////////////   SCSS
import './videojs-video-player.styles.scss';
///////////////////////////////////////////////////////////   INTERFACE
export interface PostProps {
  videoJsPlayer: any[];
  userConfig: any[];
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class VideojsPlayerPage extends React.Component<PostProps, { [key: string]: any }> {
  constructor(props: PostProps) {
    super(props);
    this.state = {
      playerType: null,
      ...this.props
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    const { videoJsPlayer } = this.state;
    this.setState({ playerType: videoJsPlayer?.playerType });
  }
  componentDidUpdate(prevProps: PostProps) {
    if (this.props.videoJsPlayer !== prevProps.videoJsPlayer) {
      this.setState({ videoJsPlayer: this.props.videoJsPlayer });
    }
    if (this.props.userConfig !== prevProps.userConfig) {
      this.setState({ userConfig: this.props.userConfig });
    }
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Layout Switch
   * This method (used to) select video-related layouts (for example: layout for syncronizing multiple-videos, layout for streaming etc.)
   * @returns JSX.Element
   */
  private layoutSwitch = (): JSX.Element => {
    const { videoJsPlayer, userConfig } = this.state;
    switch (videoJsPlayer?.playerType) {
      case _SETTINGS.playerType.standard:
        return this.singlePlayer(videoJsPlayer, userConfig);
      case _SETTINGS.playerType.embed:
        this.hideBodyScroll();
        return this.singlePlayer(videoJsPlayer, userConfig);
      default:
        return <></>;
    }
  };

  /**
   * Set player type
   * Based on videojs config, method will set player type
   * @param tpye embed or standard
   * @returns viod | string
   */
  private setPlayerType = (tpye: any) => {
    return tpye ? this.setState({ playerType: tpye }) : this.state.playerType;
  };
  /**
   * Get correct resolution list
   * Method filters vod resolution list
   * @param resolutions videojs config resolution list
   * @returns any[]
   */
  private getCorrectResolutionList = (resolutions: any[]): any[] => {
    for (let i = 0; i < resolutions.length; i++) {
      resolutions[i].data = resolutions[i].data.filter((el: any) => el.opt === true);
    }
    return resolutions.filter((i) => i.data.length > 0);
  };

  /**
   * Hide scrollbar for body
   * Case of embed player type method hides browser's scrollbar
   */
  private hideBodyScroll = (): void => {
    const elm: any = document.getElementsByTagName('body')[0];
    elm.cssText = ' overflow-y: hidden;!important';
  };

  /**
   * Layout for a single video player
   * @param settings
   * @returns
   */
  private singlePlayer = (param: any, userConfig: any): JSX.Element => {
    return (
      <>
        <div id='temporarity'>
          <img id='temporarityImg' alt='tempImg' />
        </div>
        <VideojsVideoPlayer userConfig={userConfig} {...param} />
      </>
    );
  };

  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return <this.layoutSwitch />;
  }
}
